<template>
    <section class="px-xl-5 px-lg-3 px-md-3 px-sm-3 px-2 pt-4 overflow-auto custom-scroll" style="height:calc(100vh - 84px)">
        <div class="row mx-0 j-center">
            <div class="col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12 px-2">
                <p class="text-center f-28 mt-4 f-600">
                    Seleccionar tu {{ $config.vendedor }}
                </p>
                <div class="row mx-0 j-center mb-3 mt-5">
                    <img :src="funImagenGeneral(24)" />
                </div>
                <p class="f-400 f-18 my-4 text-center">
                    Para comprar es necesario seleccionar el <span class="text-green f-600">{{ $config.vendedor }}</span> <br />
                    que atenderá tus pedidos y los llevará hasta tu casa.
                </p>
                <div class="row mx-0 mt-5 justify-content-xl-between justify-content-lg-between justify-content-md-between justify-content-sm-center justify-content-center">
                    <div class="col-auto px-2 btn">
                        <div class="row mx-0 j-center" @click="seleccionLeechero">
                            <div class="btn-purple">
                                <i class="icon-barcode f-20" />
                            </div>
                        </div>
                        <p class="text-center f-14 mt-2 f-500">
                            Tengo un código <br /> de {{ $config.vendedor }}
                        </p>
                    </div>
                    <div class="col-auto px-2 btn" @click="seleccionLeecheroAuto">
                        <div class="row mx-0 j-center">
                            <div class="btn-orange">
                                <i class="icon-loading f-24" />
                            </div>
                        </div>
                        <p class="text-center f-14 mt-2 f-500">
                            Seleccionar <br /> automáticamente
                        </p>
                    </div>
                    <div v-if="$config.menu.nomina" class="col-auto mt-xl-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4 px-2 btn" @click="irBuscarConvenio">
                        <div class="row mx-0 j-center">
                            <div class="btn-green">
                                <i class="icon-handshake f-25" />
                            </div>
                        </div>
                        <p class="text-center f-14 mt-2 f-500">
                            Tengo un convenio <br /> de nómina
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mx-0 justify-content-around mt-5 mb-4">
            <p class="col-12 text-center f-28 mt-4 f-600 mb-5">
                ¿Qué es un {{ $config.vendedor }}?
            </p>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 mb-xl-0 mb-lg-0 mb-md-0 mb-sm-5 mb-5 px-0">
                <div class="row mx-0 j-center">
                    <img :src="funImagenGeneral(48)" width="250" height="250" />
                </div>
                <p class="text-center f-400 mt-4">
                    Ahora tendrás un asesor personal y dedicado para suplir tus necesidades de compra sin salir de casa. El {{ $config.vendedor }} que selecciones estará pendiente de tus necesidades y pedidos.
                </p>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 mb-xl-0 mb-lg-0 mb-md-0 mb-sm-5 mb-5 px-0">
                <div class="row mx-0 j-center">
                    <img :src="funImagenGeneral(24)" width="250" height="250" />
                </div>
                <p class="text-center f-400 mt-4">
                    Tu {{ $config.vendedor }} garantiza la entrega de tus pedidos en la puerta de tu casa, en la fecha y horario que tu lo necesites.
                </p>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 mb-xl-0 mb-lg-0 mb-md-0 mb-sm-5 mb-5 px-0">
                <div class="row mx-0 j-center">
                    <img :src="funImagenGeneral(25)" width="250" height="250" />
                </div>
                <p class="text-center f-400 mt-4">
                    ¿Tienes alguna pregunta, queja o novedad? Tu {{ $config.vendedor }} estará presto a resolver cualquier situación, es el canal directo y rápido para solucionar cualquier duda o problema.
                </p>
            </div>
        </div>
        <modal-seleccionar-leechero ref="modalSeleccionarLeechero" @leecheroSeleccionado="aHome" />
        <modal-seleccionar-leechero-automatico ref="modalSeleccionarLeecheroAutomatico" @leecheroSeleccionado="aHome" />
        <modal-buscar-convenio ref="buscarConvenio" />
    </section>
</template>

<script>
import Nomina from '~/services/nomina/nomina'
export default {
    components: {
        modalSeleccionarLeechero: () => import('./partials/modalSeleccionarLeechero.vue'),
        modalSeleccionarLeecheroAutomatico: () => import('./partials/modalSeleccionarLeecheroAutomatico.vue'),
        modalBuscarConvenio: () => import('../../pages/convenio/partials/modalBuscarConvenio.vue'),
    },
    data(){
        return {

        }
    },
    methods: {
        seleccionLeechero(){
            this.$refs.modalSeleccionarLeechero.toggle();
        },
        seleccionLeecheroAuto(){
            this.$refs.modalSeleccionarLeecheroAutomatico.toggle();
        },
        aHome(){
            this.$router.push({name: 'home'})
        },
        async irBuscarConvenio(){
            try {
                const {data} = await Nomina.getUserConvenio();
                if(data){
                    switch(data.convenio.estado){
                    case 0:
                    case 4:
                    case 5:
                    case 6:
                        return this.$refs.buscarConvenio.toggle();
                    case 1:
                    case 2:
                    case 3:
                        return this.$router.push({name: 'convenio', params:{ idConvenio: data.convenio.id_convenio }});
                    }
                }
                this.$refs.buscarConvenio.toggle();
            }catch(e){
                this.errorCatch(e)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.btn-purple{
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: #A186DC;
    border-radius: 12px;
    .icon-barcode::before{
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
}
.btn-orange{
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: #F19D74;
    border-radius: 12px;
}

.btn-green{
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: #85DDB3;
    border-radius: 12px;
}



</style>

